import { FC } from 'react';
import { getInferredChipText } from '../../utils/skillHistoryUtils';
import { CompactRatingDisplay } from '../common';
import { RevisitIcon } from '../icons/RevisitIcon';

interface SkillHistoryEntry {
  chipType: 'in-progress' | 'assessment-result' | 'revisit' | 'inferred';
  assessmentScore?: number;
  maxScore?: number;
  skillSubstateId?: number;
  inferredBy?: string;
}

const SkillHistoryChip: FC<{ entry: SkillHistoryEntry }> = ({ entry }) => {
  switch (entry.chipType) {
    case 'in-progress':
      return (
        <span className="tw-px-2 tw-py-1 tw-rounded-full tw-text-xs tw-font-medium tw-bg-blue-100 tw-text-blue-800">
          In Progress
        </span>
      );
    case 'assessment-result':
      return (
        <div className="tw-flex tw-items-center tw-gap-2">
          {entry.assessmentScore !== undefined && entry.maxScore && (
            <CompactRatingDisplay score={entry.assessmentScore} className="tw-text-xs" />
          )}
        </div>
      );
    case 'revisit':
      return (
        <div className="tw-flex tw-items-center tw-gap-2 tw-rounded-md tw-py-[2px] tw-px-[10px] tw-text-blue-500">
          <RevisitIcon className="tw-w-4 tw-h-4" />
          <span className=" tw-font-atkinson tw-text-sm tw-font-bold">Revisit this</span>
        </div>
      );
    case 'inferred': {
      const inferredText = entry.skillSubstateId ? getInferredChipText(entry.skillSubstateId) : '';
      return (
        <span className="tw-px-2 tw-py-1 tw-rounded-full tw-text-xs tw-font-medium tw-bg-green-100 tw-text-green-800">
          {inferredText}
        </span>
      );
    }
    default:
      return null;
  }
};

export default SkillHistoryChip;
